import { render, staticRenderFns } from "./PaoYingChup.vue?vue&type=template&id=c67fe9cc&scoped=true&"
import script from "./PaoYingChup.vue?vue&type=script&lang=js&"
export * from "./PaoYingChup.vue?vue&type=script&lang=js&"
import style0 from "./PaoYingChup.vue?vue&type=style&index=0&id=c67fe9cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67fe9cc",
  null
  
)

export default component.exports